import { namespace } from "@douban/rexxar-web";
export function createListener(nsp, n, cb) {
    var existedListener = namespace(nsp)[n];
    namespace(nsp)[n] = function (jstr) {
        try {
            existedListener && existedListener(jstr);
        }
        catch (e) {
            console && console.error(jstr);
        }
        var data = undefined;
        try {
            data = JSON.parse(jstr);
        }
        catch (e) {
            console && console.error("listenMessageFromClient: ".concat(name, ", parse failed; ").concat(jstr));
        }
        if (data && cb) {
            return cb(data);
        }
        return cb();
    };
}
//# sourceMappingURL=utils.js.map